import { authedApiFetch } from '../../utils/Api';
import { Outlet, useOutletContext } from 'react-router';
import { Box } from '@mui/material';

export async function action({ request, params }) {
	const requestJson = await request.json();
	const { name, serviceId, environment, ...settings } = requestJson;

	const connection = await authedApiFetch({
		method: 'POST',
		endpoint: `/tenants/${params.tenantId}/connections`,
		payload: {
			name: name,
			settings: settings,
			environment: environment,
			service_id: serviceId,
		},
	});

	return connection;
}

const Connections = () => {
	const { tenant, user } = useOutletContext();
	// No longer using jobDataPromise

	return (
		<Box
			sx={{
				height: 'calc(100vh - 122px)',
				boxSizing: 'border-box',
				display: 'flex',
				flexDirection: 'column',
				paddingTop: '12px',
			}}
		>
			{/* <Typography variant="h4" sx={{ mb: 2, px: 3 }}>Connections</Typography> */}
			<Box
				sx={{
					flexGrow: 1,
					overflow: 'auto',
					p: 3,
				}}
			>
				<Outlet
					context={{
						tenant,
						user,
					}}
				/>
			</Box>
		</Box>
	);
};

export default Connections;
